module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-bordered"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [(_vm.localStats.tickets > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.tickets,
      "icon": "fa fa-headset",
      "caption": "All",
      "color": "slateblue",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketPending > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketPending,
      "icon": "fa fa-random",
      "caption": "Pending",
      "color": "goldenrod",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/pending"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketReview > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketReview,
      "icon": "fa fa-eye",
      "caption": "Review",
      "color": "indianred",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/review"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketOpen > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketOpen,
      "icon": "fa fa-folder-open",
      "caption": "Open",
      "color": "slategrey",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/open"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.active > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.active,
      "icon": "fa fa-tasks",
      "caption": "Active",
      "color": "navy",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/active"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketOverdue > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketOverdue,
      "icon": "fa fa-hourglass-end",
      "caption": "Overdue",
      "color": "orange",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/overdue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketUrgent > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketUrgent,
      "background": "antique white",
      "icon": "fa fa-chevron-up",
      "caption": "Urgent",
      "color": "orange",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/null/urgent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketCritical > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketCritical,
      "background": "antique white",
      "icon": "fa fa-asterisk",
      "caption": "Critical",
      "color": "indianred",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/null/critical"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.localStats.ticketClosed > 0) ? _c('el-col', {
    attrs: {
      "align": "center",
      "xs": _vm.media.xs,
      "sm": _vm.media.sm,
      "md": _vm.media.md,
      "lg": _vm.media.lg
    }
  }, [_c('dash-text', {
    attrs: {
      "value": _vm.localStats.ticketClosed,
      "icon": "fa fa-folder",
      "caption": "Closed",
      "no-plural": "",
      "size": _vm.iconSize,
      "caption-size": _vm.height,
      "align": _vm.pos,
      "url": "/tickets/completed-closed"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5185cfbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maintenance/TicketStats.vue
// module id = 1561
// module chunks = 0